import { ReviewTypeKey } from '@/modules/shared/hr-form-engine';

export type ReviewStatusField = 'Self' | 'PeerList' | 'Annual' | 'Confirmation' | 'HalfYearly' | 'Special' | 'Management';

/** PmReview column that tracks each review type's status. */
export const REVIEW_STATUS_FIELD: Record<ReviewTypeKey, ReviewStatusField> = {
  self: 'Self',
  peer: 'PeerList',
  annual: 'Annual',
  confirmation: 'Confirmation',
  half_yearly: 'HalfYearly',
  special: 'Special',
  management: 'Management',
};

/** Reviewer groups scored on the performance dashboard (legacy QualitativeCalculationService). */
export const REVIEWER_GROUPS = ['Senior Peer', 'Equal Peer', 'Junior Peer', 'Other Peer', 'Self', 'Head'] as const;
export type ReviewerGroup = (typeof REVIEWER_GROUPS)[number];

/** Legacy PmFormConstants for the auto-appended peer-skills Likert question. */
export const SKILLS_LIKERT_QUESTION = 'Skills Assessment';
export const SKILLS_LIKERT_DESCRIPTION = 'Rate the selected skills.';
export const SKILLS_LIKERT_LABELS = ['Needs Improvement', 'Meets Expectations', 'Exceeds Expectations', 'Outstanding'];
